interface HeroBackgroundProps {
  className?: string;
}

export function HeroBackground({ className = "" }: HeroBackgroundProps) {
  return (
    <div
      className={`hero-background  absolute inset-0 bg-gradient-to-br from-yellow-50 via-blue-50 to-green-100 z-[0] ${className}`}
    >
      <div className="absolute inset-0 z-[0] opacity-40">
        <div
          className="absolute inset-0 z-[0]"
          style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fillRule='evenodd'%3E%3Cg fill='%239C92AC' fillOpacity='0.05'%3E%3Ccircle cx='30' cy='30' r='2'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
          }}
        />
      </div>
    </div>
  );
}
